import { NotFoundPageLoadable } from 'pages/NotFound/NotFoundPageLoadable';

export function CmsContentPageReplaceLocation({ url }: { url: string }) {
  if (typeof window === 'undefined') return <NotFoundPageLoadable noLayout />;
  window.location.replace(url);
  return null;
}
